/**
 * Server-driven config API.
 *
 * GET /api/config/extension is the single deployed source of truth for which
 * export integrations are actually reachable in this environment. The server's
 * resolveIntegrations() (see server lib/integrationCredentials.ts) turns OFF any
 * provider whose OAuth credentials are absent, so the extension never advertises
 * a Connect button that would 500 with CONFIG_ERROR.
 *
 * The dashboard reads the same resolved list so its Settings integration cards
 * gate Connect identically. Before this, the cards advertised every provider
 * unconditionally — a real user clicked Connect on Asana four times and got a
 * guaranteed 500 each time because ASANA_CLIENT_ID wasn't deployed. The gate was
 * added for the extension (config route) but never for the dashboard, which had
 * no config consumer at all.
 *
 * The endpoint handles anonymous requests, and availability is environment-wide
 * (identical for every user), so this is fetched without a token.
 */
import type { ExtensionRemoteConfig } from '@overlayqa/shared';
import { fetchApi } from './client';
import { SCREEN_READ_TIMEOUT_MS } from './requestTimeout';

export const configApi = {
  getExtensionConfig: () => fetchApi<ExtensionRemoteConfig>('/config/extension', { timeoutMs: SCREEN_READ_TIMEOUT_MS }),
};
